<template lang="pug">
  .hero.pading-y-l
    .img-wrap
      img.img(src="@/assets/hero.png")
    //- h1.fz-h-l-3.t-center 搭建网站，像搭积木一样简单又好玩。
    h1.lh-h.fz-lll.f-z-h-l-3.t-center Compose. Publish. Share.
    //- Build website together.
    //- p.fz-p-l-2.color-text-2 Bento 是一个为 6 – 199 岁用户设计的网站协作搭建平台。
    p.lh-p.fz-m.f-z-p-l-2.color-text-2.t-center.max-w Bento is a collaboration platform designed for users aged 6 - 199 to create websites, presentations, documents and much more. 
    //- .sign-up
      //- .coming-soon.radius-l.bg-2
        .text
          .fz-p-s.color-text-2 45%
          .fz-p-s.color-text-2 private beta
        .progress.pill.clip
          .current.pill
        p.fz-p-s.color-text-2.t-center About to launch the beta, sign up for early access.
    .stack1
      SignUp.sign-up-form
      Share
</template>

<style lang="stylus" scoped>
@require '../styles/layout/main'
@require '../styles/design/main'

.center
  align-slef center

.hero
    stack(y, gap: 2rem, ali: center)
    max-width 100%
    min-width 100%
.img-wrap
  // height 400px
  width 580px
  max-width 100%
  // background red
  position relative
  .img
    margin-top -150px
    width 100%
    // background blue
    position relative
  // width 60%
  // top -100px
  // min-width 100%
  // background: rgb(0,0,0);
  // background: linear-gradient(0deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0) 100%);
.coming-soon
  stack(y, gap: 0.5rem)
  border-radius 1rem
  padding 1.5rem
  width 100%
  max-width 26rem
  align-self center
  // padding 1rem
  .text
    stack(x, arr: between)
  .progress
    background var(--clr-shadow)
    height .25rem
    // max-width 16rem
    min-width 50%
    // align-self stretch
    .current
      width 45%
      background var(--clr-primary)
      height 100%
.stack1
  stack(y, gap: 1rem, ali: center)
  width 560px
  max-width 100%
.sign-up-form
  width 560px
  max-width 100%

  // background #000
// .sign-up[max-width~="399px"]
  // &>*
  //   width max-content
// .sign-up[min-width~="600px"]
//   .sign-up-form
//     width 600px
//     max-width 100%
  // &>*
  //   width 80%
</style>

<script>
import SignUp from "@/components/signup.vue";
import Share from "@/components/share.vue";

export default {
  components: {
    SignUp,
    Share
  }
};
</script>
